export default function ProgressDots({ sections, activeId, onJump }) {
  if (!Array.isArray(sections) || sections.length < 2) return null;

  return (
    <nav
      aria-label="Page sections"
      className="pointer-events-none fixed bottom-6 left-1/2 z-30 hidden -translate-x-1/2 flex-row items-center gap-3 sm:flex"
    >
      {sections.map((section, idx) => {
        const isActive = activeId === section.id;
        return (
          <button
            key={section.id}
            type="button"
            onClick={() => onJump(section.id)}
            aria-label={`Section ${idx + 1} of ${sections.length}: ${section.label}`}
            aria-current={isActive ? 'true' : undefined}
            className={`pointer-events-auto rounded-full transition-all duration-200 ${
              isActive ? 'h-2 w-5 bg-tf-teal' : 'h-2 w-2 bg-tf-ink/25 hover:bg-tf-ink/55'
            }`}
          />
        );
      })}
    </nav>
  );
}
